module.exports = __webpack_public_path__ + "static/slider_2-6b64cae3c46281eb4673513e42dd253f.jpg";